import { css as f, LitElement as w, html as h, nothing as g } from "lit";
import { query as d, property as s, state as m, customElement as y } from "lit/decorators.js";
import { classMap as v } from "lit/directives/class-map.js";
import { o as b, f as E, s as x, a as $, c as T, b as A } from "./floating-ui.dom-Cma46hoU.js";
import { b as D } from "./styles-scZ6dVz-.js";
import { g as S } from "./a11y-DxQW21Jt.js";
var P = Object.defineProperty, O = Object.getOwnPropertyDescriptor, e = (r, i, p, a) => {
  for (var o = a > 1 ? void 0 : a ? O(i, p) : i, l = r.length - 1, n; l >= 0; l--)
    (n = r[l]) && (o = (a ? n(i, p, o) : n(o)) || o);
  return a && o && P(i, p, o), o;
};
let t = class extends w {
  constructor() {
    super(...arguments), this.tooltipId = S("ark-tooltip"), this.content = "", this.placement = "top", this.offset = 8, this.showArrow = !0, this.showDelay = 200, this.hideDelay = 0, this.disabled = !1, this.open = !1, this.arrowSide = "bottom";
  }
  async updatePosition() {
    if (!this.triggerElement || !this.tooltipElement) return;
    const r = this.triggerElement.querySelector("slot")?.assignedElements()[0] || this.triggerElement, i = [
      b(this.offset),
      E(),
      x({ padding: 8 })
    ];
    this.showArrow && this.arrowElement && i.push($({ element: this.arrowElement }));
    const { x: p, y: a, placement: o, middlewareData: l } = await T(
      r,
      this.tooltipElement,
      {
        placement: this.placement,
        middleware: i
      }
    );
    if (Object.assign(this.tooltipElement.style, {
      left: `${p}px`,
      top: `${a}px`
    }), this.showArrow && l.arrow) {
      const { x: n, y: u } = l.arrow, c = o.split("-")[0];
      this.arrowSide = {
        top: "bottom",
        bottom: "top",
        left: "right",
        right: "left"
      }[c], Object.assign(this.arrowElement.style, {
        left: n != null ? `${n}px` : "",
        top: u != null ? `${u}px` : "",
        [this.arrowSide]: "-4px"
      });
    }
  }
  show() {
    this.disabled || !this.content || (clearTimeout(this.hideTimeout), this.showTimeout = window.setTimeout(() => {
      this.open = !0, this.updatePosition();
      const r = this.triggerElement.querySelector("slot")?.assignedElements()[0] || this.triggerElement;
      this.cleanupAutoUpdate = A(
        r,
        this.tooltipElement,
        () => this.updatePosition()
      );
    }, this.showDelay));
  }
  hide() {
    clearTimeout(this.showTimeout), this.hideTimeout = window.setTimeout(() => {
      this.open = !1, this.cleanupAutoUpdate?.();
    }, this.hideDelay);
  }
  handleMouseEnter() {
    this.show();
  }
  handleMouseLeave() {
    this.hide();
  }
  handleFocus() {
    this.show();
  }
  handleBlur() {
    this.hide();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), clearTimeout(this.showTimeout), clearTimeout(this.hideTimeout), this.cleanupAutoUpdate?.();
  }
  render() {
    if (!this.content)
      return h`<slot></slot>`;
    const r = {
      tooltip: !0,
      open: this.open
    };
    return h`
      <span
        part="trigger"
        class="trigger"
        @mouseenter=${this.handleMouseEnter}
        @mouseleave=${this.handleMouseLeave}
        @focusin=${this.handleFocus}
        @focusout=${this.handleBlur}
        aria-describedby=${this.tooltipId}
      >
        <slot></slot>
      </span>

      <div
        part="tooltip"
        class=${v(r)}
        id=${this.tooltipId}
        role="tooltip"
        aria-hidden=${!this.open}
      >
        ${this.content}
        ${this.showArrow ? h`<div part="arrow" class="arrow"></div>` : g}
      </div>
    `;
  }
};
t.styles = [
  D,
  f`
      :host {
        display: inline-block;
      }

      .trigger {
        display: inline-flex;
      }

      .tooltip {
        position: fixed;
        z-index: var(--r5-z-tooltip);
        background-color: var(--r5-tooltip-bg, var(--r5-color-neutral-900));
        color: var(--r5-tooltip-color, white);
        border-radius: var(--r5-radius-md);
        padding: var(--r5-space-1-5) var(--r5-space-2-5);
        font-size: var(--r5-text-xs);
        font-weight: var(--r5-font-medium);
        line-height: var(--r5-leading-normal);
        max-width: 20rem;
        pointer-events: none;
        opacity: 0;
        visibility: hidden;
        transform: scale(0.95);
        transition: opacity var(--r5-duration-fast) var(--r5-ease-default),
                    visibility var(--r5-duration-fast) var(--r5-ease-default),
                    transform var(--r5-duration-fast) var(--r5-ease-default);
      }

      .tooltip.open {
        opacity: 1;
        visibility: visible;
        transform: scale(1);
      }

      .arrow {
        position: absolute;
        width: 0.5rem;
        height: 0.5rem;
        background-color: var(--r5-tooltip-bg, var(--r5-color-neutral-900));
        transform: rotate(45deg);
      }

      @media (prefers-reduced-motion: reduce) {
        .tooltip {
          transition: none;
        }
      }
    `
];
e([
  d(".trigger")
], t.prototype, "triggerElement", 2);
e([
  d(".tooltip")
], t.prototype, "tooltipElement", 2);
e([
  d(".arrow")
], t.prototype, "arrowElement", 2);
e([
  s({ type: String })
], t.prototype, "content", 2);
e([
  s({ type: String })
], t.prototype, "placement", 2);
e([
  s({ type: Number })
], t.prototype, "offset", 2);
e([
  s({ type: Boolean, attribute: "show-arrow" })
], t.prototype, "showArrow", 2);
e([
  s({ type: Number, attribute: "show-delay" })
], t.prototype, "showDelay", 2);
e([
  s({ type: Number, attribute: "hide-delay" })
], t.prototype, "hideDelay", 2);
e([
  s({ type: Boolean, reflect: !0 })
], t.prototype, "disabled", 2);
e([
  m()
], t.prototype, "open", 2);
e([
  m()
], t.prototype, "arrowSide", 2);
t = e([
  y("ark-tooltip")
], t);
export {
  t as A
};
//# sourceMappingURL=ark-tooltip-Bjdd6Woe.js.map
